export default "__VITE_ASSET__DUpz5Ci9__"